'use client'
import{a as e,c as o}from"./chunk-4K73N3NP.mjs";import{LineChart as n}from"@tremor/react";import{jsx as i}from"react/jsx-runtime";var l=C=>{var t=C,{data:a}=t,r=o(t,["data"]);return i(n,e({data:a,colors:r.colors||["emerald","gray"]},r))};export{l as a};
